import { render, staticRenderFns } from "./GjwSpaceHeader.vue?vue&type=template&id=53687c50&scoped=true"
import script from "./GjwSpaceHeader.vue?vue&type=script&lang=js"
export * from "./GjwSpaceHeader.vue?vue&type=script&lang=js"
import style0 from "./GjwSpaceHeader.vue?vue&type=style&index=0&id=53687c50&prod&lang=less&scoped=true"
import style1 from "./GjwSpaceHeader.vue?vue&type=style&index=1&id=53687c50&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53687c50",
  null
  
)

export default component.exports